import React, { useRef, useState } from "react";
import Webcam from "react-webcam";

interface Props {
	onCapturePhoto: (image: File) => void;
}

const WebcamCapture: React.FC<Props> = (props) => {
	const { onCapturePhoto } = props;

	const webcamRef = useRef<Webcam | null>(null);

	const [imageSrc, setImageSrc] = useState<string | null>(null);
	const [showCamera, setShowCamera] = useState(false);

	const isDesktop = window.innerWidth <= 768;

	const handleStartCapture = () => {
		setImageSrc(null);
		setShowCamera(true);
	};

	const handleStopCapture = () => {
		setShowCamera(false);
	};

	const handleCapture = () => {
		const imageSrc = webcamRef.current?.getScreenshot();

		if (onCapturePhoto && imageSrc) {
			var arr = imageSrc.split(","),
				mime = arr?.[0]?.match(/:(.*?);/)?.[1],
				bstr = atob(arr[arr.length - 1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);

			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}

			let _fileName = `catturaWebcam_${new Date().toTimeString()}.jpg`;
			let _file = new File([u8arr], _fileName, { type: mime });

			onCapturePhoto(_file);
		}
		if (imageSrc) {
			setImageSrc(imageSrc);
		}
		handleStopCapture();
	};

	if (isDesktop) {
		return null;
	}

	return (
		<div className="">
			{showCamera ? (
				<div className="">
					<Webcam
						audio={false}
						ref={webcamRef}
						screenshotFormat="image/jpeg"
						style={{ width: "100%", height: "50%" }}
						className=" my-2 container"
					/>
					<div className="d-flex justify-content-around ">
						<button onClick={handleCapture} className="btn btn-primary mt-2">
							Cattura Immagine
						</button>
						<button onClick={handleStopCapture} className="btn btn-primary mt-2">
							Chiudi Camera
						</button>
					</div>
				</div>
			) : (
				<button onClick={handleStartCapture} className="btn btn-primary px-4 ">
					Scatta
				</button>
			)}
		</div>
	);
};

export default WebcamCapture;
